import { useState, useMemo } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function LoanCalculator() {
  const [amount, setAmount] = useState(250000);
  const [rate, setRate] = useState(6.5);
  const [years, setYears] = useState(30);

  var result = useMemo(function () {
    var p = amount;
    var r = rate / 100 / 12;
    var n = years * 12;
    if (r === 0) return { monthly: p / n, totalPaid: p, totalInterest: 0 };
    var monthly = p * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
    var totalPaid = monthly * n;
    return { monthly: monthly, totalPaid: totalPaid, totalInterest: totalPaid - p };
  }, [amount, rate, years]);

  var fmt = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };

  return (
    <div className="page-prettifier">
      <SEO title="Loan & Mortgage Calculator - Free Monthly Payment Calculator" description="Free online loan and mortgage calculator. Calculate monthly payments, total interest, and total cost for any loan amount, interest rate, and term." path="/loan-calculator" />
      <div className="container">
        <div className="tool-header">
          <h1>Loan & Mortgage Calculator</h1>
          <p>Calculate your monthly payment, total interest, and total cost for any loan or mortgage.</p>
        </div>
        <AdUnit />
        <div className="calc-layout">
          <div className="calc-inputs">
            <div className="form-group">
              <label htmlFor="loan-amount">Loan Amount (₹)</label>
              <input id="loan-amount" type="number" min="0" value={amount} onChange={function (e) { setAmount(parseFloat(e.target.value) || 0); }} className="color-input" />
            </div>
            <div className="form-group">
              <label htmlFor="loan-rate">Annual Interest Rate (%)</label>
              <input id="loan-rate" type="number" min="0" max="50" step="0.1" value={rate} onChange={function (e) { setRate(parseFloat(e.target.value) || 0); }} className="color-input" />
            </div>
            <div className="form-group">
              <label htmlFor="loan-years">Loan Term (years)</label>
              <input id="loan-years" type="number" min="1" max="50" value={years} onChange={function (e) { setYears(parseInt(e.target.value) || 1); }} className="color-input" />
            </div>
          </div>
          <div className="calc-results">
            <div className="stat-card" style={{ flex: 'none', width: '100%' }}>
              <div className="stat-number">{fmt(result.monthly)}</div>
              <div className="stat-label">Monthly Payment</div>
            </div>
            <div className="stats-grid" style={{ width: '100%' }}>
              <div className="stat-card"><div className="stat-number">{fmt(result.totalPaid)}</div><div className="stat-label">Total Paid</div></div>
              <div className="stat-card"><div className="stat-number">{fmt(result.totalInterest)}</div><div className="stat-label">Total Interest</div></div>
            </div>
          </div>
        </div>
        <section className="tool-guide">
          <h2>How Loan Payments Work</h2>
          <p>Your monthly payment is calculated using the loan amount, interest rate, and loan term. A longer term means lower monthly payments but more total interest paid. A shorter term means higher monthly payments but less interest overall. Use this calculator to compare different scenarios and find the right balance for your budget.</p>
          <h2>Tips for Getting a Better Rate</h2>
          <ul>
            <li>Improve your credit score before applying — even a small increase can save thousands.</li>
            <li>Compare offers from multiple lenders, including banks, credit unions, and online lenders.</li>
            <li>Consider a shorter loan term if you can afford higher monthly payments.</li>
            <li>Make extra payments toward the principal when possible to reduce total interest.</li>
            <li>Look into refinancing if rates drop significantly after you take out your loan.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default LoanCalculator;
